import React, { useState } from 'react';
import { EvidiaModal } from '../EvidiaModal/EvidiaModal';

interface Props {
	title?: React.ReactNode;
	description?: React.ReactNode;
	children: React.ReactNode;
	okText?: string;
	cancelText?: string;
	okButtonIcon?: React.ReactNode;
	onConfirm?: () => Promise<void> | void;
	onCancel?: () => Promise<void> | void;
}

export const ConfirmModal: React.FC<Props> = ({
	children,
	title,
	description,
	okText,
	cancelText,
	okButtonIcon,
	onConfirm,
	onCancel,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	const onClick = () => {
		setIsOpen(true);
	};

	const handleOk = async () => {
		setLoading(true);
		await onConfirm?.();
		setIsOpen(false);
		setLoading(false);
	};

	const handleCancel = async () => {
		await onCancel?.();
		setIsOpen(false);
	};

	const clonedChildren = React.cloneElement(children as any, { onClick });

	return (
		<>
			{clonedChildren}
			<EvidiaModal
				title={title}
				open={isOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				okText={okText}
				cancelText={cancelText}
				okButtonProps={{
					icon: okButtonIcon,
					danger: true,
					type: 'default',
					loading,
				}}
				cancelButtonProps={{
					disabled: loading,
				}}
				data-testid="confirm-modal"
			>
				{description}
			</EvidiaModal>
		</>
	);
};
